module.exports = __webpack_public_path__ + "img/dahlia-alt.fb326d19.png";